import React, { useEffect } from "react";

// Set GATSBY_DISABLE_ONETRUST=true in .env to disable OneTrust (e.g. while testing CookieYes).
// Both CMPs running simultaneously will conflict — OneTrust claims consent management first
// and CookieYes's cookie policy injection never completes.
const ONETRUST_DISABLED = process.env.GATSBY_DISABLE_ONETRUST === 'true'

const OneTrust = (props) => {

    useEffect(() => {
        if (ONETRUST_DISABLED) return

        const script_one = document.createElement('script');

        script_one.src = "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
        script_one.defer = true;
        script_one.setAttribute("data-domain-script", "c3ef871f-9a88-426b-b804-3bab3258b697")

        document.body.appendChild(script_one);

    }, [])

    return (
        <></>
    )
}

export default OneTrust
